import { render, staticRenderFns } from "./VerifyOndato.vue?vue&type=template&id=a74c4d70&scoped=true&"
import script from "./VerifyOndato.vue?vue&type=script&lang=js&"
export * from "./VerifyOndato.vue?vue&type=script&lang=js&"
import style0 from "./VerifyOndato.vue?vue&type=style&index=0&id=a74c4d70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a74c4d70",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VFlex,VIcon})
